import { RadioOption } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/Settings/components/ControlledRadioGroup';
import { FinalFormProfile } from '../types/profileTypes';
import { SlDropdownMenuOption } from '@stackline/ui';
import { store } from 'src/main';
import axios from 'axios';
const CONTENT_ENDPOINT = '/api/beaconcontent';

export const fetchProfiles = (status: string) => async () => {
  const endpoint = `${CONTENT_ENDPOINT}/GetProfiles?status=${status}`;
  const response = await axios.get(endpoint);
  const data = await response.data;
  const userId = store.getState().user.session?.userId;

  if (status === 'OWNED') {
    return data.data.filter((profile: FinalFormProfile & { createdBy: string }) => profile.createdBy === userId);
  }
  return data.data;
};

export const bulletPointsCountOptions: RadioOption[] = [
  { id: 5, label: '5 bullet points' },
  { id: 6, label: '6 bullet points' },
  { id: 7, label: '7 bullet points' },
  { id: 8, label: '8 bullet points' },
  { id: 9, label: '9 bullet points' },
  { id: 10, label: '10 bullet points' }
];

/**
 * Do not lowercase or manipulate the id. Some logics assumes id is exactly the same as label
 */
export const arrayToOptions = (inputs: readonly string[]): SlDropdownMenuOption[] => {
  if (!inputs || inputs.length === 0) {
    return [];
  }
  return Object.values(inputs).map((v) => ({ id: v, label: v }));
};

export const DEFAULT_PROFILE_NAME = '';

export const DEFAULT_NEW_PROFILE: FinalFormProfile = {
  profileName: DEFAULT_PROFILE_NAME,
  profileDescription: 'Automatically generated default profile for content generation',
  variant: 'add',
  settings: {
    voice: {
      type: 'Informative',
      intensity: 'Moderate'
    },
    tone: {
      type: 'Friendly',
      intensity: 'Moderate'
    },
    bulletPointsCount: 5,
    characterLimits: {
      titles: 200,
      bullets: 250,
      descriptions: 2000
    },
    keywords: {
      inclusion: [],
      exclusion: [],
      shouldIncludeStacklineRecommendedKeywords: true
    },
    aiInstructions: '',
    guidelines: [],
    keywordDensity: 15
  }
};
